import { ACCOUNTTYPES } from './types/Types';

export class Client{
    name:string;
    phone:string;
    email:String;
    applications:any[]=[];
    active:boolean;
    subscription:string=null;
    accounttype:ACCOUNTTYPES;
    password:string;
    exisitingUser:string;
    created_on:Date;

    // existingUsername:string;

}
